module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "mt-3"
  }, [_vm._v("Sales Channels")]), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "changes": function($event) {
        return _vm.eventActivateUpdateFlag('SalesChannels')
      }
    }
  }, [_c('div', {
    staticClass: "row mt-5"
  }, [_c('div', {
    staticClass: "col-sm-10 ml-4"
  }, [_c('div', {
    staticClass: "form-group channelOptions"
  }, [_c('div', {
    staticClass: "mb-2 w-100 dark fs-small"
  }, [_c('span', {
    staticClass: "pointer hoverLink",
    on: {
      "click": function($event) {
        return _vm.selectAll(true)
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('span', [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "pointer hoverLink",
    on: {
      "click": function($event) {
        return _vm.selectAll(false)
      }
    }
  }, [_vm._v("None")])]), _vm._v(" "), _vm._l((_vm.sortedSalesChannels), function(salesChannel) {
    return _c('div', {
      staticClass: "full mb-3 pRelative mb-3"
    }, [_c('div', {
      staticClass: "d-flex align-items-center justify-content-between"
    }, [_c('div', {}, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('checkbox', {
      staticClass: "mt-1",
      on: {
        "input": function($event) {
          return _vm.salesChannelStateChanged(salesChannel)
        }
      },
      model: {
        value: (salesChannel.isActive),
        callback: function($$v) {
          _vm.$set(salesChannel, "isActive", $$v)
        },
        expression: "salesChannel.isActive"
      }
    }, [_vm._v("\n                                        " + _vm._s(salesChannel.channelName) + "\n                                    ")]), _vm._v(" "), (salesChannel.channelType == 50) ? _c('div', {
      staticClass: "ml-2"
    }, [_c('v-select', {
      attrs: {
        "options": _vm.agentsChannelOptions,
        "disabled": !salesChannel.isActive
      },
      on: {
        "input": function($event) {
          return _vm.agentsChannelOptionsChanged($event, salesChannel)
        }
      },
      model: {
        value: (_vm.selectedAgentsChannelOptions),
        callback: function($$v) {
          _vm.selectedAgentsChannelOptions = $$v
        },
        expression: "selectedAgentsChannelOptions"
      }
    })], 1) : _vm._e()], 1), _vm._v(" "), (salesChannel.channelType == 50 && salesChannel.isActive && _vm.selectedAgentsChannelOptions.value != false) ? _c('div', [(_vm.getSelectedEvent.salesPermissionsAgentsCustom) ? _c('div', {
      staticClass: "d-flex flex-column pRelative ml-4"
    }, [_c('agent-white-list', {
      staticClass: "mt-2",
      attrs: {
        "allowedList": _vm.getSelectedEvent.salesPermissionsAgentsList,
        "blockedList": _vm.getSelectedEvent.salesBlockedAgentList,
        "startAllSelected": _vm.customAgentListSelectAll
      },
      on: {
        "input": _vm.agentListChanged
      }
    })], 1) : _vm._e()]) : _vm._e()])])])
  })], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0a672139", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a672139"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/EventEdit/areaSalesPermissions.vue
// module id = 1381
// module chunks = 0